import { createUserManager } from 'redux-oidc';

const config = (window as any).tcx_transportationinsights_configs;

const configuration = {
    client_id: config.client_id,
    redirect_uri: `${config.login_url}/callback`,
    response_type: 'code',
    scope: `openid ${config.app_name}`,
    authority: config.authorize_url,
    loadUserInfo: false,
    post_logout_redirect_uri: config.login_url,
    revokeAccessTokenOnSignout: true,
    automaticSilentRenew: true
};

const AuthenticationManager = createUserManager(configuration);

export default AuthenticationManager;
